import { useEffect } from 'react';
import { ANALYTICS_PAGE_ID } from '@config/logging';
import { Page } from '@config/page';
import { computePageViewData, sendPageView } from '@helpers/logging/analytics/page-view-event';
import { geometryGetType } from '@selectors/geometry';
import { useEventBus } from '@hooks/logging';
import { useNavigator } from '@hooks/routing';
import { useStorage } from '@hooks/storage';
import { useTypedSelector } from '@hooks/store';
import { AboutScene } from '@scenes/about';
import { LayoutWidget } from '@widgets/layout';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const AboutPage: Page = () => {
  const eventBus = useEventBus();
  const storage = useStorage();
  const navigator = useNavigator();
  const geometryType = useTypedSelector(geometryGetType);
  const title = 'О нас';
  useEffect(() => {
    const _sendPageView = async () => {
      sendPageView(eventBus, {
        ...(await computePageViewData({
          navigator,
          storage,
          geometryType
        })),
        pageId: ANALYTICS_PAGE_ID.ABOUT
      });
    };
    _sendPageView();
  }, [eventBus, geometryType, navigator, storage]);
  return _jsx(AboutScene, {
    title: title
  });
};
AboutPage.layout = LayoutWidget;
export default AboutPage;